import { useState, useEffect } from "react";
import PageBanner from "../components/PageBanner";
import Seo from "../components/Seo";
import { Reveal } from "../components/Motion";
import { useApp, api } from "../AppContext";
import { C, IMAGES } from "../content";
import { Pin } from "lucide-react";

export default function News() {
  const { t, lang } = useApp();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/news").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <Seo title="News & Announcements" description="Latest notices, circulars and appeals from Sadguru Swami Narayanand Tirth Seva Trust, Audumbar." />
      <PageBanner label={lang === "mr" ? "सूचना" : "Announcements"} titleObj={C.news} image={IMAGES.ashramGate} />
      <section className="py-16 lg:py-24 max-w-[900px] mx-auto px-4 lg:px-8">
        <div className="space-y-5">
          {items.map((n, i) => (
            <Reveal key={n.id} delay={i * 0.05}>
              <article className={`rounded-2xl border p-6 lg:p-8 ${n.pinned ? "border-saffron-500/40 bg-saffron-500/5" : "border-earth-900/10 bg-white"}`} data-testid={`news-${i}`}>
                <div className="flex items-center gap-3 mb-2">
                  {n.pinned && <span className="inline-flex items-center gap-1 text-xs font-semibold text-saffron-600"><Pin size={14} /> {lang === "mr" ? "महत्त्वाचे" : "Pinned"}</span>}
                  {n.date && <span className="text-sm text-earth-600">{n.date}</span>}
                </div>
                <h3 className="font-serif-head text-2xl lg:text-3xl text-earth-900">{t(n, "title")}</h3>
                <p className="mt-2 text-earth-800/80 text-lg">{t(n, "body")}</p>
              </article>
            </Reveal>
          ))}
          {items.length === 0 && <p className="text-earth-600">{lang === "mr" ? "सध्या कोणत्याही सूचना नाहीत." : "No announcements yet."}</p>}
        </div>
      </section>
    </div>
  );
}
